import * as React from 'react'
import type { SVGProps, Ref } from 'react'
import { forwardRef } from 'react'
interface SVGRProps {
  title?: string
  titleId?: string
}
const SvgShahr = (
  { title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps,
  ref: Ref<SVGSVGElement>,
) => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='1em'
    height='1em'
    fill='none'
    viewBox='0 0 24 24'
    ref={ref}
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <g clipPath='url(#shahr_svg__a)'>
      <path
        fill='#ED1C24'
        fillRule='evenodd'
        d='m11.97 17.755.035-3.536c.146-.006 1.622-.065 2.53.393a.58.58 0 0 1 .366.611c0 1.062-2.867 2.574-3.149 2.722C8.121 19.797 3 20.113 3 20.113L3.048 24c2.19-.305 6.144-.75 10.913-3.336 2.36-1.277 4.913-3.387 4.437-6.393-.461-2.906-3.504-3.725-6.37-3.6l-.033 3.536c-.145.007-1.622.065-2.53-.392a.58.58 0 0 1-.366-.61c0-1.063 2.867-2.575 3.149-2.721C15.879 8.63 21 8.316 21 8.316l-.048-3.887c-2.192.305-6.144.75-10.913 3.336-2.36 1.277-4.913 3.387-4.436 6.393.46 2.906 3.503 3.725 6.368 3.599zM7.294 3.758c.438 0 .866.132 1.23.378s.648.595.815 1.004a2.26 2.26 0 0 1-.48 2.44 2.193 2.193 0 0 1-2.413.485 2.2 2.2 0 0 1-.994-.825 2.255 2.255 0 0 1 .276-2.826c.415-.42.978-.656 1.566-.656M17.169 0c.438 0 .866.13 1.23.377.365.245.65.595.817 1.004a2.26 2.26 0 0 1-.48 2.44 2.192 2.192 0 0 1-2.414.485 2.2 2.2 0 0 1-.994-.825 2.255 2.255 0 0 1 .276-2.826c.415-.42.978-.655 1.565-.655m-5.153 1.469c.438 0 .866.13 1.23.375.365.246.65.595.817 1.003a2.26 2.26 0 0 1-.476 2.44 2.193 2.193 0 0 1-2.412.49 2.2 2.2 0 0 1-.995-.822 2.26 2.26 0 0 1-.207-2.099 2.24 2.24 0 0 1 1.198-1.21c.27-.113.557-.17.848-.17z'
        clipRule='evenodd'
      />
    </g>
    <defs>
      <clipPath id='shahr_svg__a'>
        <path fill='#fff' d='M0 0h24v24H0z' />
      </clipPath>
    </defs>
  </svg>
)
const ForwardRef = forwardRef(SvgShahr)
export default ForwardRef
